var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaaromVonnisbankRaadplegen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "460.78px",
    height: "358.209px",
    viewBox: "0 0 460.78 358.209",
    enableBackground: "new 0 0 460.78 358.209",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A2D0FE",
    d: "M187.346,99.927h38.401l7.712,15.886c0,0-20.312-2.973-27.089,20.015l-21.599-23.131L187.346,99.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2D0FE",
    d: "M208.635,213.893c0,0,3.969,5.43,4.564,10.305s7.471,1.875,7.471,1.875l3.875-1.625l-2.337-11.533 L208.635,213.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M0,184.571c0,1.104,0.896,2,2,2h456.78c1.104,0,2-0.896,2-2v-5.826c0-1.104-0.896-2-2-2H2 c-1.104,0-2,0.896-2,2V184.571z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M96.507,268.917c0,1.104,0.896,2,2,2h79.502c1.105,0,2-0.896,2-2v-3.558c0-1.104-0.895-2-2-2H98.507 c-1.104,0-2,0.896-2,2V268.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M102.428,269.695c1.04-0.372,1.581-1.516,1.208-2.557L50.475,117.96c-0.372-1.04-1.518-1.581-2.558-1.208 l-3.349,1.199c-1.04,0.372-1.581,1.518-1.208,2.557l53.161,149.18c0.372,1.04,1.517,1.58,2.557,1.208L102.428,269.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M77.591,216.262l-9.007,3.213c-1.039,0.375-1.575,1.522-1.199,2.561l10.485,28.497 c0.377,1.039,1.523,1.575,2.561,1.199l8.781-2.861"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M84.12,270.917v3.578c0,7.751,6.284,14.035,14.035,14.035h33.51c7.75,0,14.033-6.284,14.033-14.035v-3.578 H84.12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.567,
    y: 283.121,
    fill: "#A6D5FF",
    width: 6.685,
    height: 55.365
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M84.349,275.868h8.568v-5h-8.568c-2.807,0-6.137-2.305-7.125-4.932l-12.476-33.074l-4.68,1.76 l12.476,33.074C74.269,272.278,79.453,275.868,84.349,275.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M77.021,345.836h4c0-2.624,2.135-4.759,4.76-4.759h24.409v-4H85.78 C80.95,337.077,77.021,341.006,77.021,345.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M148.892,345.836h4c0-4.83-3.93-8.759-8.759-8.759h-24.409v4h24.409 C146.757,341.077,148.892,343.212,148.892,345.836z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A6D5FF",
    cx: 150.892,
    cy: 349.461,
    r: 6.125
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A6D5FF",
    cx: 79.058,
    cy: 349.461,
    r: 6.125
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M64.039,245.217c0.585,1.551,2.315,2.334,3.865,1.749l7.887-2.976c1.55-0.585,2.333-2.315,1.748-3.866 l-4.177-11.072c-0.586-1.55-2.316-2.333-3.867-1.748l-7.886,2.976c-1.55,0.585-2.333,2.315-1.748,3.866L64.039,245.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M103.569,340.336c0,1.656,1.343,3,3,3h16.682c1.656,0,3-1.344,3-3v-6.725c0-1.656-1.344-3-3-3h-16.682 c-1.657,0-3,1.344-3,3V340.336z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M379.697,308.701c0,1.104,0.896,2,2,2h3.362c1.104,0,1.999-0.896,1.999-2V183.658c0-1.104-0.896-2-1.999-2 h-3.362c-1.104,0-2,0.896-2,2V308.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BADFF",
    d: "M403.54,297.5v-7.202c0-1.962,1.596-3.558,3.558-3.558h7.203c1.962,0,3.558,1.596,3.558,3.558v7.202 c0,1.962-1.596,3.558-3.558,3.558h-7.203C405.136,301.058,403.54,299.462,403.54,297.5z M407.098,290.298l-0.002,7.202h7.205 v-7.202H407.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M266.309,147.052c0,1.104,0.896,2,2,2h122.069c1.104,0,2-0.896,2-2V70.378c0-1.104-0.896-2-2-2H268.309 c-1.104,0-2,0.896-2,2V147.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M271.878,142.396c0,0.553,0.448,1,1,1h112.93c0.553,0,1-0.447,1-1V74.878c0-0.553-0.447-1-1-1h-112.93 c-0.552,0-1,0.447-1,1V142.396z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.701,
    y: 263.948,
    fill: "#5BADFF",
    width: 7.996,
    height: 37.109
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M353.698,176.745v-13.001c0-1.104-0.896-2-2-2h-44.71c-1.104,0-2,0.896-2,2v13.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M367.409,323.495c0,0.951,0.771,1.723,1.723,1.723h82.958c0.951,0,1.723-0.771,1.723-1.723v-42.787 l-8.613-15.043c0-0.951-0.771-1.723-1.723-1.723h-65.729c-0.951,0-1.723,0.771-1.723,1.723l-8.615,16.225V323.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M427.943,263.941c0.053-0.532,0.082-1.07,0.086-1.615c0.07-9.618-7.672-17.475-17.293-17.543 c-9.619-0.072-17.475,7.671-17.543,17.29c-0.006,0.633,0.023,1.257,0.085,1.871l5.635-0.002c-0.088-0.597-0.132-1.207-0.126-1.828 c0.047-6.53,5.379-11.787,11.91-11.738c6.53,0.047,11.786,5.379,11.738,11.91c-0.004,0.564-0.047,1.119-0.128,1.662 L427.943,263.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D5FF",
    d: "M372.132,263.942h27.479h22.176h27.479c5.569,0,6.466,12.139,6.466,21.084c0,4.382,0,5.85,0,5.85h-34.271 h-21.525h-34.271c0,0,0-1.468,0-5.85C365.665,276.081,366.562,263.942,372.132,263.942z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.409,
    y: 290.876,
    opacity: 0.5,
    fill: "#7CBDFF",
    width: 86.403,
    height: 4.109
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M406.701,286.78v-22.832h7.996v22.832c1.773,0.2,3.161,1.691,3.161,3.518v7.202 c0,1.826-1.388,3.317-3.161,3.518v0.04h-0.396h-7.203h-0.396v-0.04c-1.773-0.2-3.161-1.691-3.161-3.518v-7.202 C403.54,288.472,404.928,286.98,406.701,286.78z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.032,
    y: 144.927,
    fill: "#A6D5FF",
    width: 12.621,
    height: 18.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.686,
    y: 115.812,
    opacity: 0.5,
    fill: "#A6D5FF",
    width: 12.743,
    height: 17.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.282,
    y: 109.832,
    opacity: 0.5,
    fill: "#A6D5FF",
    width: 12.743,
    height: 23.509
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.289,
    y: 106.158,
    opacity: 0.5,
    fill: "#A6D5FF",
    width: 12.743,
    height: 27.183
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.382,
    y: 94.587,
    opacity: 0.5,
    fill: "#A6D5FF",
    width: 12.743,
    height: 38.754
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#A6D5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 284.407,
    y1: 84.436,
    x2: 284.407,
    y2: 133.341
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#A6D5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 373.104,
    y1: 133.341,
    x2: 284.407,
    y2: 133.341
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#D4145A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 356.058,115.812 335.653,109.832 316.661,106.158 296.753,94.587 284.407,88.699  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D4145A",
    cx: 280.953,
    cy: 40.405,
    r: 10.409
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M305.08,41.908c0-2.782,1.57-4.605,3.741-4.605s3.742,1.823,3.742,4.605s-1.571,4.605-3.742,4.605 S305.08,44.69,305.08,41.908z M311.712,41.908c0-2.411-1.211-3.826-2.891-3.826c-1.679,0-2.89,1.415-2.89,3.826 c0,2.41,1.211,3.838,2.89,3.838C310.501,45.746,311.712,44.318,311.712,41.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M314.236,40.025h0.827v0.995c0.611-0.6,1.415-1.115,2.41-1.115c1.248,0,1.884,0.695,1.884,1.871v4.569 h-0.828v-4.413c0-0.888-0.396-1.319-1.259-1.319c-0.815,0-1.499,0.419-2.207,1.103v4.63h-0.827V40.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M322.035,45.482v0.863h-0.828v-8.875h0.828v3.478c0.504-0.563,1.163-1.043,2.11-1.043 c1.451,0,2.603,1.067,2.603,3.274c0,2.206-1.163,3.274-2.674,3.274C323.259,46.454,322.599,46.058,322.035,45.482z  M325.921,43.191c0-1.751-0.863-2.578-1.919-2.578c-0.779,0-1.367,0.407-1.967,1.043v3.07c0.624,0.659,1.235,1.031,1.967,1.031 C325.117,45.758,325.921,44.979,325.921,43.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M327.963,43.18c0-2.243,1.439-3.274,2.771-3.274c1.476,0,2.579,1.127,2.579,3.286v0.156h-4.522 c0.013,1.559,0.9,2.435,1.991,2.435c0.947,0,1.487-0.408,1.967-1.151l0.516,0.407c-0.552,0.888-1.331,1.439-2.53,1.439 C329.258,46.478,327.963,45.338,327.963,43.18z M332.509,42.688c-0.084-1.199-0.66-2.087-1.787-2.087 c-0.912,0-1.764,0.66-1.919,2.087H332.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M335.308,44.87v-4.138h-1.104v-0.707h1.104v-2.267h0.827v2.267h1.644v0.707h-1.644v3.97 c0,0.672,0.216,1.032,0.995,1.032c0.24,0,0.48-0.024,0.66-0.084v0.707c-0.192,0.036-0.528,0.072-0.815,0.072 C335.763,46.43,335.308,45.962,335.308,44.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M338.871,44.87c0-1.247,1.068-2.158,4.282-2.65v-0.323c0-0.876-0.456-1.296-1.283-1.296 c-0.996,0-1.703,0.42-2.363,0.996l-0.443-0.516c0.756-0.696,1.631-1.176,2.878-1.176c1.416,0,2.027,0.756,2.027,2.015v2.866 c0,0.768,0.048,1.235,0.18,1.56h-0.852c-0.084-0.264-0.144-0.54-0.144-0.899c-0.731,0.659-1.547,1.008-2.495,1.008 C339.531,46.454,338.871,45.854,338.871,44.87z M343.153,44.774v-1.967c-2.711,0.456-3.466,1.127-3.466,1.955 c0,0.659,0.443,1.008,1.151,1.008C341.726,45.771,342.506,45.398,343.153,44.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M345.436,44.87c0-1.247,1.067-2.158,4.281-2.65v-0.323c0-0.876-0.456-1.296-1.283-1.296 c-0.996,0-1.703,0.42-2.363,0.996l-0.443-0.516c0.756-0.696,1.631-1.176,2.879-1.176c1.415,0,2.026,0.756,2.026,2.015v2.866 c0,0.768,0.048,1.235,0.18,1.56h-0.852c-0.084-0.264-0.144-0.54-0.144-0.899c-0.731,0.659-1.547,1.008-2.495,1.008 C346.095,46.454,345.436,45.854,345.436,44.87z M349.717,44.774v-1.967c-2.711,0.456-3.466,1.127-3.466,1.955 c0,0.659,0.443,1.008,1.151,1.008C348.289,45.771,349.069,45.398,349.717,44.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M352.455,37.471h0.828v8.875h-0.828V37.471z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M354.915,43.191c0-2.207,1.164-3.286,2.675-3.286c0.815,0,1.547,0.432,2.039,0.983v-3.418h0.827v7.315 c0,0.768,0.048,1.235,0.192,1.56h-0.876c-0.071-0.216-0.144-0.588-0.144-0.924c-0.516,0.552-1.163,1.032-2.111,1.032 C356.066,46.454,354.915,45.398,354.915,43.191z M359.629,44.715v-3.07c-0.624-0.672-1.235-1.044-1.967-1.044 c-1.115,0-1.919,0.815-1.919,2.603c0,1.739,0.863,2.543,1.919,2.543C358.441,45.746,359.029,45.351,359.629,44.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M362.019,43.18c0-2.243,1.439-3.274,2.771-3.274c1.476,0,2.578,1.127,2.578,3.286v0.156h-4.521 c0.013,1.559,0.9,2.435,1.991,2.435c0.947,0,1.487-0.408,1.967-1.151l0.516,0.407c-0.552,0.888-1.331,1.439-2.53,1.439 C363.313,46.478,362.019,45.338,362.019,43.18z M366.564,42.688c-0.084-1.199-0.66-2.087-1.787-2.087 c-0.912,0-1.764,0.66-1.919,2.087H366.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M372.109,40.732h-1.103v-0.707h1.103v-0.947c0-1.067,0.612-1.619,1.812-1.619 c0.156,0,0.372,0.012,0.479,0.023v0.695c-0.096-0.012-0.288-0.023-0.42-0.023c-0.611,0-1.043,0.228-1.043,0.911v0.96h1.391v0.707 h-1.391v5.613h-0.828V40.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M375.219,44.87c0-1.247,1.067-2.158,4.281-2.65v-0.323c0-0.876-0.456-1.296-1.283-1.296 c-0.996,0-1.703,0.42-2.363,0.996l-0.443-0.516c0.756-0.696,1.631-1.176,2.879-1.176c1.415,0,2.026,0.756,2.026,2.015v2.866 c0,0.768,0.048,1.235,0.18,1.56h-0.852c-0.084-0.264-0.144-0.54-0.144-0.899c-0.731,0.659-1.547,1.008-2.495,1.008 C375.878,46.454,375.219,45.854,375.219,44.87z M379.5,44.774v-1.967c-2.711,0.456-3.466,1.127-3.466,1.955 c0,0.659,0.443,1.008,1.151,1.008C378.072,45.771,378.853,45.398,379.5,44.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M381.807,43.191c0-2.267,1.403-3.286,2.818-3.286c1.355,0,2.027,0.804,2.423,1.727l-0.708,0.312 c-0.348-0.852-0.852-1.331-1.738-1.331c-0.936,0-1.968,0.671-1.968,2.566c0,1.655,0.84,2.591,1.943,2.591 c0.876,0,1.367-0.408,1.812-1.344l0.671,0.288c-0.504,1.067-1.235,1.763-2.519,1.763C383.09,46.478,381.807,45.29,381.807,43.191z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M388.971,44.87v-4.138h-1.104v-0.707h1.104v-2.267h0.827v2.267h1.644v0.707h-1.644v3.97 c0,0.672,0.216,1.032,0.995,1.032c0.24,0,0.48-0.024,0.66-0.084v0.707c-0.192,0.036-0.528,0.072-0.815,0.072 C389.426,46.43,388.971,45.962,388.971,44.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M392.858,44.595v-4.569h0.827v4.426c0,0.887,0.385,1.319,1.26,1.319c0.804,0,1.487-0.433,2.195-1.104 v-4.642h0.839v6.32h-0.839v-0.995c-0.612,0.6-1.416,1.127-2.399,1.127C393.482,46.478,392.858,45.771,392.858,44.595z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M399.891,40.025h0.827v1.247h0.023c0.492-0.779,1.26-1.367,2.507-1.367h0.145l-0.084,0.768 c0,0-0.229-0.012-0.252-0.012c-1.031,0-1.848,0.575-2.339,1.571v4.113h-0.827V40.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M404.27,43.18c0-2.243,1.439-3.274,2.771-3.274c1.476,0,2.579,1.127,2.579,3.286v0.156h-4.522 c0.013,1.559,0.9,2.435,1.991,2.435c0.947,0,1.487-0.408,1.967-1.151l0.516,0.407c-0.552,0.888-1.331,1.439-2.53,1.439 C405.564,46.478,404.27,45.338,404.27,43.18z M408.815,42.688c-0.084-1.199-0.66-2.087-1.787-2.087 c-0.912,0-1.764,0.66-1.919,2.087H408.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M411.182,40.025h0.828v0.995c0.611-0.6,1.415-1.115,2.41-1.115c1.248,0,1.884,0.695,1.884,1.871v4.569 h-0.828v-4.413c0-0.888-0.396-1.319-1.259-1.319c-0.815,0-1.5,0.419-2.207,1.103v4.63h-0.828V40.025z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#072441",
    d: "M225.692,177.926c3.139,0.546,6.408-0.94,7.99-3.905c1.547-2.895,1.024-6.344-1.053-8.653l-42.945-42.603 c-1.716-1.695-3.695-3.21-5.934-4.407c-12.468-6.653-27.971-1.942-34.626,10.527c-6.654,12.466-1.943,27.969,10.524,34.623 c2.317,1.237,4.736,2.081,7.188,2.556L225.692,177.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#072441",
    d: "M233.776,174.501l11.884-63.736l-7.265-2.296l-24.877,46.899 C213.519,155.368,217.292,180.552,233.776,174.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0083E8",
    d: "M179.158,99.133c-38.503,0-71.843,54.65-71.843,108.643c0,13.545,4.76,29.359,4.76,29.359l32.728-9.417 c0-29.074,33.248-59.584,48.125-59.584L179.158,99.133z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D4145A",
    cx: 280.953,
    cy: 10.408,
    r: 10.409
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M305.08,11.911c0-2.782,1.57-4.605,3.741-4.605s3.742,1.823,3.742,4.605s-1.571,4.605-3.742,4.605 S305.08,14.693,305.08,11.911z M311.712,11.911c0-2.411-1.211-3.826-2.891-3.826c-1.679,0-2.89,1.415-2.89,3.826 c0,2.41,1.211,3.838,2.89,3.838C310.501,15.749,311.712,14.321,311.712,11.911z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M314.236,10.028h0.827v0.995c0.611-0.6,1.415-1.115,2.41-1.115c1.248,0,1.884,0.695,1.884,1.871v4.569 h-0.828v-4.413c0-0.888-0.396-1.319-1.259-1.319c-0.815,0-1.499,0.419-2.207,1.103v4.63h-0.827V10.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M322.035,15.485v0.863h-0.828V7.474h0.828v3.478c0.504-0.563,1.163-1.043,2.11-1.043 c1.451,0,2.603,1.067,2.603,3.274c0,2.206-1.163,3.274-2.674,3.274C323.259,16.457,322.599,16.061,322.035,15.485z  M325.921,13.194c0-1.751-0.863-2.578-1.919-2.578c-0.779,0-1.367,0.407-1.967,1.043v3.07c0.624,0.659,1.235,1.031,1.967,1.031 C325.117,15.761,325.921,14.981,325.921,13.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M327.963,13.183c0-2.243,1.439-3.274,2.771-3.274c1.476,0,2.579,1.127,2.579,3.286v0.156h-4.522 c0.013,1.559,0.9,2.435,1.991,2.435c0.947,0,1.487-0.408,1.967-1.151l0.516,0.407c-0.552,0.888-1.331,1.439-2.53,1.439 C329.258,16.48,327.963,15.341,327.963,13.183z M332.509,12.69c-0.084-1.199-0.66-2.087-1.787-2.087 c-0.912,0-1.764,0.66-1.919,2.087H332.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M335.308,14.873v-4.138h-1.104v-0.707h1.104V7.762h0.827v2.267h1.644v0.707h-1.644v3.97 c0,0.672,0.216,1.032,0.995,1.032c0.24,0,0.48-0.024,0.66-0.084v0.707c-0.192,0.036-0.528,0.072-0.815,0.072 C335.763,16.433,335.308,15.965,335.308,14.873z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M338.871,14.873c0-1.247,1.068-2.158,4.282-2.65v-0.323c0-0.876-0.456-1.296-1.283-1.296 c-0.996,0-1.703,0.42-2.363,0.996l-0.443-0.516c0.756-0.696,1.631-1.176,2.878-1.176c1.416,0,2.027,0.756,2.027,2.015v2.866 c0,0.768,0.048,1.235,0.18,1.56h-0.852c-0.084-0.264-0.144-0.54-0.144-0.899c-0.731,0.659-1.547,1.008-2.495,1.008 C339.531,16.457,338.871,15.856,338.871,14.873z M343.153,14.777v-1.967c-2.711,0.456-3.466,1.127-3.466,1.955 c0,0.659,0.443,1.008,1.151,1.008C341.726,15.773,342.506,15.401,343.153,14.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M345.436,14.873c0-1.247,1.067-2.158,4.281-2.65v-0.323c0-0.876-0.456-1.296-1.283-1.296 c-0.996,0-1.703,0.42-2.363,0.996l-0.443-0.516c0.756-0.696,1.631-1.176,2.879-1.176c1.415,0,2.026,0.756,2.026,2.015v2.866 c0,0.768,0.048,1.235,0.18,1.56h-0.852c-0.084-0.264-0.144-0.54-0.144-0.899c-0.731,0.659-1.547,1.008-2.495,1.008 C346.095,16.457,345.436,15.856,345.436,14.873z M349.717,14.777v-1.967c-2.711,0.456-3.466,1.127-3.466,1.955 c0,0.659,0.443,1.008,1.151,1.008C348.289,15.773,349.069,15.401,349.717,14.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M352.455,7.474h0.828v8.875h-0.828V7.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M354.915,13.194c0-2.207,1.164-3.286,2.675-3.286c0.815,0,1.547,0.432,2.039,0.983V7.474h0.827v7.315 c0,0.768,0.048,1.235,0.192,1.56h-0.876c-0.071-0.216-0.144-0.588-0.144-0.924c-0.516,0.552-1.163,1.032-2.111,1.032 C356.066,16.457,354.915,15.401,354.915,13.194z M359.629,14.718v-3.07c-0.624-0.672-1.235-1.044-1.967-1.044 c-1.115,0-1.919,0.815-1.919,2.603c0,1.739,0.863,2.543,1.919,2.543C358.441,15.749,359.029,15.354,359.629,14.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M362.019,13.183c0-2.243,1.439-3.274,2.771-3.274c1.476,0,2.578,1.127,2.578,3.286v0.156h-4.521 c0.013,1.559,0.9,2.435,1.991,2.435c0.947,0,1.487-0.408,1.967-1.151l0.516,0.407c-0.552,0.888-1.331,1.439-2.53,1.439 C363.313,16.48,362.019,15.341,362.019,13.183z M366.564,12.69c-0.084-1.199-0.66-2.087-1.787-2.087 c-0.912,0-1.764,0.66-1.919,2.087H366.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M370.994,10.028h0.888l1.871,5.337h0.024l1.858-5.337h0.84l-2.327,6.345h-0.827L370.994,10.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M377.391,13.194c0-2.11,1.308-3.286,2.866-3.286c1.548,0,2.854,1.176,2.854,3.286 c0,2.099-1.307,3.286-2.854,3.286C378.71,16.48,377.391,15.293,377.391,13.194z M382.284,13.183c0-1.38-0.696-2.566-2.027-2.566 c-1.283,0-2.039,1.079-2.039,2.566c0,1.403,0.685,2.591,2.039,2.591C381.528,15.773,382.284,14.705,382.284,13.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M384.674,10.028h0.828v0.995c0.611-0.6,1.415-1.115,2.41-1.115c1.248,0,1.884,0.695,1.884,1.871v4.569 h-0.828v-4.413c0-0.888-0.396-1.319-1.259-1.319c-0.815,0-1.5,0.419-2.207,1.103v4.63h-0.828V10.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M391.646,10.028h0.827v0.995c0.611-0.6,1.415-1.115,2.41-1.115c1.248,0,1.884,0.695,1.884,1.871v4.569 h-0.828v-4.413c0-0.888-0.396-1.319-1.259-1.319c-0.815,0-1.499,0.419-2.207,1.103v4.63h-0.827V10.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M398.666,7.678h0.875v0.887h-0.875V7.678z M398.689,10.028h0.828v6.32h-0.828V10.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M401.054,15.341l0.527-0.479c0.48,0.552,1.092,0.912,1.968,0.912c1.079,0,1.643-0.396,1.643-1.104 c0-0.696-0.504-0.972-1.739-1.26c-1.451-0.359-2.194-0.743-2.194-1.847c0-0.899,0.779-1.655,2.146-1.655 c1.08,0,1.775,0.359,2.339,0.911l-0.468,0.552c-0.479-0.479-1.079-0.779-1.847-0.779c-0.983,0-1.367,0.456-1.367,0.936 c0,0.611,0.432,0.863,1.535,1.127c1.583,0.384,2.398,0.768,2.398,2.003c0,1.151-1.031,1.812-2.459,1.812 C402.409,16.469,401.533,15.989,401.054,15.341z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M407.126,15.341l0.527-0.479c0.48,0.552,1.092,0.912,1.968,0.912c1.079,0,1.643-0.396,1.643-1.104 c0-0.696-0.504-0.972-1.739-1.26c-1.451-0.359-2.194-0.743-2.194-1.847c0-0.899,0.779-1.655,2.146-1.655 c1.08,0,1.775,0.359,2.339,0.911l-0.468,0.552c-0.479-0.479-1.079-0.779-1.847-0.779c-0.983,0-1.367,0.456-1.367,0.936 c0,0.611,0.432,0.863,1.535,1.127c1.583,0.384,2.398,0.768,2.398,2.003c0,1.151-1.031,1.812-2.459,1.812 C408.481,16.469,407.605,15.989,407.126,15.341z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M413.282,13.183c0-2.243,1.439-3.274,2.771-3.274c1.476,0,2.578,1.127,2.578,3.286v0.156h-4.521 c0.013,1.559,0.9,2.435,1.991,2.435c0.947,0,1.487-0.408,1.967-1.151l0.516,0.407c-0.552,0.888-1.331,1.439-2.53,1.439 C414.577,16.48,413.282,15.341,413.282,13.183z M417.828,12.69c-0.084-1.199-0.66-2.087-1.787-2.087 c-0.912,0-1.764,0.66-1.919,2.087H417.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B6EAE",
    d: "M420.193,10.028h0.828v0.995c0.611-0.6,1.415-1.115,2.41-1.115c1.248,0,1.884,0.695,1.884,1.871v4.569 h-0.828v-4.413c0-0.888-0.396-1.319-1.259-1.319c-0.815,0-1.5,0.419-2.207,1.103v4.63h-0.828V10.028z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 276.195,
    y1: 5.65,
    x2: 285.71,
    y2: 15.166
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 285.709,
    y1: 5.65,
    x2: 276.194,
    y2: 15.166
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 276.195,
    y1: 35.647,
    x2: 285.71,
    y2: 45.163
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 285.709,
    y1: 35.647,
    x2: 276.194,
    y2: 45.163
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#114374",
    cx: 181.509,
    cy: 342.255,
    r: 5.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#114374",
    cx: 181.891,
    cy: 348.001,
    r: 5.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#114374",
    cx: 211.069,
    cy: 345.365,
    r: 9.345
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#114374",
    points: "211.679,336.037 182.11,338.005 181.4,348.89 210.46,354.688  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#072441",
    cx: 218.357,
    cy: 245.567,
    r: 5.157
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#072441",
    d: "M179.493,334.021c0,0-6.217-15.679,0.706-34.765c15.386-42.428,34.888-51.357,37.365-58.19l4.743,7.373 l-31.991,88.212L179.493,334.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDFC",
    d: "M176.418,335.038c0.125,1.878,1.748,3.298,3.625,3.174l12.08-0.804c1.878-0.124,3.299-1.747,3.174-3.625 l0,0c-0.125-1.877-1.748-3.298-3.625-3.173l-12.08,0.803C177.714,331.538,176.293,333.161,176.418,335.038L176.418,335.038z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#114374",
    points: "176.066,342.617 176.475,348.769 179.697,350.217 183.791,341.776  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114374",
    d: "M226.253,342.536c0.056,3.408,2.862,6.126,6.271,6.07c3.409-0.054,6.128-2.86,6.074-6.269 c-0.055-3.41-2.863-6.129-6.272-6.073C228.917,336.318,226.198,339.127,226.253,342.536z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#114374",
    cx: 232.53,
    cy: 348.952,
    r: 6.172
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#114374",
    cx: 265.66,
    cy: 347.632,
    r: 10.576
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#114374",
    points: "266.879,337.124 233.348,337.667 231.924,349.93 264.44,358.138  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DF3CE",
    cx: 228.302,
    cy: 237.956,
    r: 5.157
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DF3CE",
    d: "M230.431,331.906c0,0-12.795-10.441-14.368-30.684c-3.496-44.995,10.58-61.179,10.017-68.426l7.364,4.76 l7.27,93.551L230.431,331.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDFC",
    d: "M226.975,334.267c0.029,1.88,1.578,3.38,3.461,3.351l12.104-0.193c1.881-0.031,3.384-1.581,3.353-3.462l0,0 c-0.03-1.881-1.58-3.382-3.462-3.351l-12.104,0.193C228.445,330.835,226.944,332.384,226.975,334.267L226.975,334.267z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#114374",
    points: "226.253,342.536 226.366,349.513 229.926,351.332 235.033,342.026  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1DF3CE",
    d: "M137.407,222.441l-24.173,5.422c0,0-3.62,6.932,0,16.249s22.504,16.468,62.685,16.468 S137.407,222.441,137.407,222.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DF3CE",
    d: "M122.182,238.841c0,0-5.93,21.739,53.737,21.739c47,0,40.08-11.869,58.619-11.869l-5.156-16.027 l-91.812-9.231L122.182,238.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DF3CE",
    d: "M145.053,224.286l0.781-4.693h-37.862c0,0-4.121,34.283,28.153,37.573L145.053,224.286z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0083E8",
    cx: 179.784,
    cy: 131.404,
    rx: 34.355,
    ry: 32.271
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#0083E8",
    points: "223.47,219.054 201.618,112.696 157.951,130.477 211.476,218.567  "
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#114374",
    d: "M182.733,171.263l-24.782-37.922l16.374,43.404 C174.325,176.745,178.984,172.983,182.733,171.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2D0FE",
    d: "M236.995,242.864c-2.244,0.001-4.185-1.676-4.462-3.959l-0.639-5.281l-17.881-1.916 c-2.472-0.265-4.26-2.483-3.995-4.954c0.267-2.473,2.497-4.26,4.954-3.995l21.438,2.298c2.083,0.224,3.736,1.854,3.988,3.934 l1.069,8.833c0.298,2.468-1.46,4.71-3.927,5.009C237.358,242.854,237.176,242.864,236.995,242.864z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#114374",
    d: "M206.252,99.927c0,0,3.687,13.197,11.957,19.29c0,0,2.348-1.353,3.843-1.866l2.251-3.548 c0,0-3.546-8.583-3.732-8.646s-7.464-5.23-7.464-5.23H206.252z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A2D0FE",
    d: "M204.002,90.102c0,17.484,22.491,35.076,42.308,35.076v-18.693l5.745-1.345l-5.77-7.694 c-0.316-12.523-3.855-20.23-9.699-24.312l-10.484,2.39l-2.973-6.083c-0.009,0-0.018,0-0.026,0 c-10.354,0-18.747,8.141-18.747,18.494C204.355,88.712,203.909,89.349,204.002,90.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114374",
    d: "M246.312,113.17c-5.78,0-10.018,3.873-10.06,3.912c-0.203,0.186-0.518,0.176-0.707-0.025 c-0.188-0.202-0.177-0.519,0.025-0.707c0.184-0.17,4.557-4.18,10.741-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DF3CE",
    d: "M245.677,66.77c-9.784,0-11.572,6.136-15.091,6.136c-4.297,0-5.766-8.856-17.496-8.856 c-8.355,0-15.334,4.651-15.334,11.667c0,8.016,4.258,8.749,4.258,15.499s0,14.83,0,18.478s2.605,5,5.466,5 c4.985,0,10.396-5.274,10.396-11.251c0-7.076-3.402-6.88-3.402-11.45c0-2.426,2.097-4.892,6.073-4.892 c4.772,0,6.726,5.092,9.546,5.092c1.191,0,3.104-1.235,3.104-3.104s0.524-4.312,3.203-4.312c4.024,0,4.583,2.604,9.277,2.604 c6.923,0,12.966-3.898,12.966-10.305C258.643,71.829,253.268,66.77,245.677,66.77z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaaromVonnisbankRaadplegen);
export default __webpack_public_path__ + "static/media/waarom-vonnisbank-raadplegen.afee1797e0eada6a0a287ddadf7349bf.svg";
export { ForwardRef as ReactComponent };